/** CF เลือกนโยบายขาย ส่วนสิทธิ์ preorder และ stock เป็นของ POS */
export type CfAllocationMode = "limit" | "unlimited";

export function resolveAllocationMode(input: {
  allocationMode?: CfAllocationMode | string | null;
  allocatedQuantity?: number | null;
}): CfAllocationMode {
  if (input.allocationMode === "unlimited") return "unlimited";
  return "limit";
}

/** ค่าใน CF ลดสิทธิ์ได้ แต่ขยายสิทธิ์เกิน POS ไม่ได้ */
export function resolveEffectiveCfAllocationMode(
  mode: CfAllocationMode,
  isPreorder: boolean,
): CfAllocationMode {
  return mode === "unlimited" && isPreorder ? "unlimited" : "limit";
}

export function toAdminCfAllocationMode(
  mode: CfAllocationMode,
): "limit" | "unlimited" {
  return mode;
}

/** ใช้ unlimited ได้เมื่อทั้ง CF และ POS อนุญาตเท่านั้น */
export function resolveStockAllocationMode(
  mode: CfAllocationMode,
  isPreorder: boolean,
): CfAllocationMode {
  return resolveEffectiveCfAllocationMode(mode, isPreorder);
}
